// extracted by mini-css-extract-plugin
module.exports = {"clientDetails":"ClientDetails_clientDetails__1HQh9"};